import AnnotationDataStream from "./AnnotationDataStream";
import MapObjectAnnotation from "@/map/element/MapObjectAnnotation";

export default class MapObjectDataStream extends AnnotationDataStream {

    constructor(id, mapService, forceAllVisible, user, publisherId, mapId, poiType) {
        super(id, forceAllVisible);

        mapService.loadMapObjectsOfType(user, publisherId, mapId, poiType).then((mapObjects) => {
            const mapElements = [];
            for (var mapObject of mapObjects) {
                if (mapObject.type == "point") {
                    mapElements.push(new MapObjectAnnotation(mapObject))
                } else {
                    console.log("trying to load unsupported object type");
                }
            }

            this.setMapElements(mapElements, true);
        }).catch((error) => {
            console.log(error);
        });
    }
}
